module.exports = __webpack_public_path__ + "media/images/activeIconRelease-2fe9b696.png";